export default __webpack_public_path__ + "static/media/ray14.147a9a72.webp";